export const FEATURE_NAME = '@zerops/zerops/core/project-base';
